export function buildDebugLogSignature(payload: unknown) {
  try {
    return JSON.stringify(payload, debugLogReplacer);
  } catch {
    return String(payload);
  }
}

function debugLogReplacer(_key: string, value: unknown) {
  if (typeof value === 'bigint') {
    return value.toString();
  }

  if (value instanceof Error) {
    return {
      name: value.name,
      message: value.message,
      stack: value.stack,
    };
  }

  if (typeof value === 'function') {
    return `[Function ${value.name || 'anonymous'}]`;
  }

  return value;
}
